import { render, staticRenderFns } from "./LanguageLevelCreateEdit.vue?vue&type=template&id=ab8b0440&scoped=true&"
import script from "./LanguageLevelCreateEdit.vue?vue&type=script&lang=js&"
export * from "./LanguageLevelCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./LanguageLevelCreateEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LanguageLevelCreateEdit.vue?vue&type=style&index=1&id=ab8b0440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8b0440",
  null
  
)

export default component.exports